export enum StatusCommission {
  UNPAID = 'UNPAID',
  PENDING = 'PENDING',
  PAID = 'PAID',
  AVAILABLE = 'AVAILABLE',
  REFUSED = 'REFUSED',
}

export enum TypeCommission {
  REFFERED = 'REFFERED',
  TRANSACTIONAL = 'TRANSACTIONAL',
  BONUS = 'BONUS',
  RETROATIVE = 'RETROATIVE',
}

export const optionsTypeSelect = [
  { value: TypeCommission.REFFERED, label: 'Indicação' },
  { value: TypeCommission.TRANSACTIONAL, label: 'Transação' },
  { value: TypeCommission.BONUS, label: 'Bônus' },
  { value: TypeCommission.RETROATIVE, label: 'Meta Atingida' },
]
